module.exports = __webpack_public_path__ + "img/Pack-min.1dcce017.png";